const dfPhotosVideos = {
  introHead: 'Organize your files',
  introDescription:
    'We help you organize and safely store important pictures and videos.',
};

export default dfPhotosVideos;
